import * as React from "react";
import Box from "@mui/material/Box";
import ChatList from "./chatlist/ChatList";
import { Drawer, useTheme } from "@mui/material";

interface ChatSidebarProps {
  isOpen: boolean;
  width: any;
}


const ChatSidebar: React.FC<ChatSidebarProps> = ({ isOpen, width }) => {
  const theme = useTheme();

  const useStyles = {
    chatContainer: {
      position: "fixed",
            top: 64,
            right: 0,
            height: "90vh",
            maxHeight:"100vh",
            width: isOpen ? width : "0",
            backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : '#F4F2FF',
            overflowX: "hidden",
            overflowY:"hidden",
            transition: "width 0.3s ease",
     
      '@media (max-width: 600px)': {
        top: 50,
      },
    },
  };
  return (
    <Drawer
      sx={{
        width: width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: width,
          boxSizing: "border-box",
          marginTop: "5rem",
          backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#F4F2FF',
          borderLeft: theme.palette.mode === 'dark' ? '#1a1a1a' : '#F4F2FF',
        },
      }}
      variant="persistent"
      anchor="right"
      open={isOpen}
    >
      <Box sx={useStyles.chatContainer}>
        <Box
          sx={{
            padding: "1px",
            display: isOpen ? "block" : "none",
          }}
        >
          <ChatList />
        </Box>
      </Box>
    </Drawer>

  );
};

export default React.memo(ChatSidebar);
